<template>
  <main class="container">
    <section class="container__section_top">
      <article class="container__section_top__article_top">
        <aside class="container__section_top__article_top__aside_top">
          <div class="container__section_top__article_top__aside_top__div">
            <h1 class="container__section_top__article_top__aside_top__div__h1">
              Compétences
            </h1>
          </div>
        </aside>
        <!--  left side -->
        <aside class="container__section_top__article_top__aside_left">
          <!-- icons -->
          <div class="container__section_top__article_top__aside_left__div_card">
            <div class="container__section_top__article_top__aside_left__div_card__div_angular">
              <div class="container__section_top__article_top__aside_left__div_card__div_angular__div_icon">
                <a href="https://fr.wikipedia.org/wiki/Angular">
                  <img src="@/assets/angularjs.png" alt="angularjs"
                    class="container__section_top__article_top__aside_left__div_card__div_angular__div_icon__img" />
                </a>
              </div>
              <div class="container__section_top__article_top__aside_left__div_card__div_angular__div_link">
                <p class="container__section_top__article_top__aside_left__div_card__div_angular__div_link__a">Angular
                </p>
              </div>
            </div>
            <div class="container__section_top__article_top__aside_left__div_card__div_vue">
              <div class="container__section_top__article_top__aside_left__div_card__div_vue__div_icon">
                <a href="https://fr.wikipedia.org/wiki/Vue.js">
                  <img src="@/assets/vue_icon.png" alt="vue_icon"
                    class="container__section_top__article_top__aside_left__div_card__div_vue__div_icon__img" />
                </a>
              </div>
              <div class="container__section_top__article_top__aside_left__div_card__div_vue__div_link">
                <p
                  class="container__section_top__article_top__aside_left__div_card__div_vue__div_link__a">Vue</p>
              </div>
            </div>
            <div class="container__section_top__article_top__aside_left__div_card__div_react">
              <div class="container__section_top__article_top__aside_left__div_card__div_react__div_icon">
                <a href="https://fr.wikipedia.org/wiki/React">
                  <img src="@/assets/react_icon.png" alt="react_icon"
                    class="container__section_top__article_top__aside_left__div_card__div_react__div_icon__img" />
                </a>

              </div>
              <div class="container__section_top__article_top__aside_left__div_card__div_react__div_link">
                <p class="container__section_top__article_top__aside_left__div_card__div_react__div_link__a">React</p>
              </div>
            </div>
            <div class="container__section_top__article_top__aside_left__div_card__div_symfony">
              <div class="container__section_top__article_top__aside_left__div_card__div_symfony__div_icon">
                <a href="https://fr.wikipedia.org/wiki/Symfony">
                  <img src="@/assets/symfony.png" alt="symfony"
                    class="container__section_top__article_top__aside_left__div_card__div_symfony__div_icon__img" />
                </a>

              </div>
              <div class="container__section_top__article_top__aside_left__div_card__div_symfony__div_link">
                <p class="container__section_top__article_top__aside_left__div_card__div_symfony__div_link__a">Symfony
                </p>
              </div>
            </div>
            <div class="container__section_top__article_top__aside_left__div_card__div_sql">
              <div class="container__section_top__article_top__aside_left__div_card__div_sql__div_icon">
                <a href="https://fr.wikipedia.org/wiki/Structured_Query_Language">
                  <img src="@/assets/sql.png" alt="sql"
                    class="container__section_top__article_top__aside_left__div_card__div_sql__div_icon__img" />
                </a>
              </div>
              <div class="container__section_top__article_top__aside_left__div_card__div_sql__div_link">
                <p class="container__section_top__article_top__aside_left__div_card__div_sql__div_link__a">SQL</p>
              </div>
            </div>
            <div class="container__section_top__article_top__aside_left__div_card__div_html5">
              <div class="container__section_top__article_top__aside_left__div_card__div_html5__div_icon">
                <a href="https://fr.wikipedia.org/wiki/HTML5">
                  <img src="@/assets/social_html5.png" alt="social_html5"
                    class="container__section_top__article_top__aside_left__div_card__div_html5__div_icon__img" />
                </a>
              </div>
              <div class="container__section_top__article_top__aside_left__div_card__div_html5__div_link">
                <p class="container__section_top__article_top__aside_left__div_card__div_html5__div_link__a">HTML 5</p>
              </div>
            </div>
            <!--  -->
            <div class="container__section_top__article_top__aside_left__div_card__div_css3">
              <div class="container__section_top__article_top__aside_left__div_card__div_css3__div_icon">
                <a href="https://fr.wikipedia.org/wiki/Feuilles_de_style_en_cascade">
                  <img src="@/assets/css3.png" alt="css3"
                    class="container__section_top__article_top__aside_left__div_card__div_css3__div_icon__img" />
                </a>
              </div>
              <div class="container__section_top__article_top__aside_left__div_card__div_css3__div_link">
                <p class="container__section_top__article_top__aside_left__div_card__div_css3__div_link__a">CSS 3</p>
              </div>
            </div>
            <!--  -->
            <div class="container__section_top__article_top__aside_left__div_card__div_js">
              <div class="container__section_top__article_top__aside_left__div_card__div_js__div_icon">
                <a href="https://fr.wikipedia.org/wiki/JavaScript">
                  <img src="@/assets/javascript_logo_icon.png" alt="javascript_logo_icon"
                    class="container__section_top__article_top__aside_left__div_card__div_js__div_icon__img" />
                </a>
              </div>
              <div class="container__section_top__article_top__aside_left__div_card__div_js__div_link">
                <p class="container__section_top__article_top__aside_left__div_card__div_js__div_link__a">Javascript</p>
              </div>
            </div>
            <!--  -->
            <div class="container__section_top__article_top__aside_left__div_card__div_php">
              <div class="container__section_top__article_top__aside_left__div_card__div_php__div_icon">
                <a href="https://fr.wikipedia.org/wiki/PHP">
                  <img src="@/assets/php.png" alt="PHP"
                    class="container__section_top__article_top__aside_left__div_card__div_php__div_icon__img" />
                </a>
              </div>
              <div class="container__section_top__article_top__aside_left__div_card__div_php__div_link">
                <a href="https://fr.wikipedia.org/wiki/PHP"
                  class="container__section_top__article_top__aside_left__div_card__div_php__div_link__a">PHP</a>
              </div>
            </div>
            <!--  -->
            <div class="container__section_top__article_top__aside_left__div_card__div_python">
              <div class="container__section_top__article_top__aside_left__div_card__div_python__div_icon">
                <a href="https://fr.wikipedia.org/wiki/Python_(langage)">
                  <img src="@/assets/Python.png" alt="Python"
                    class="container__section_top__article_top__aside_left__div_card__div_python__div_icon__img" />
                </a>

              </div>
              <div class="container__section_top__article_top__aside_left__div_card__div_python__div_link">
                <p class="container__section_top__article_top__aside_left__div_card__div_python__div_link__a">Python</p>
              </div>
            </div>
          </div>
        </aside>
        <!-- right aside -->
        <aside class="container__section_top__article_top__aside_right">
          <!-- right side -->
          <div class="container__section_top__article_top__aside_right__div_top">
            <div class="container__section_top__article_top__aside_right__div_top__div_titre">
              <h1 class="container__section_top__article_top__aside_right__div_top__div_titre__h1">
                Développeur Web
              </h1>
            </div>
            <div class="container__section_top__article_top__aside_right__div_top__div_text">
              <p class="container__section_top__article_top__aside_right__div_top__div_text__p">
                Web mobile
                <br />
                Full Stack
              </p>
            </div>
          </div>
          <!-- flex direction column -->
          <div class="container__section_top__article_top__aside_right__div_bottom">
            <button class="container__section_top__article_top__aside_right__div_bottom__button">
              <router-link to="/services#web"
                class="container__section_top__article_top__aside_right__div_bottom__button__router-link">
                Prestations
              </router-link>
            </button>
          </div>
        </aside>
      </article>
      <!-- ******************* -->
      <!-- vidéo -->
      <!-- ******************* -->
      <article class="container__section_top__article_bottom">
        <div class="container__section_top__article_bottom__div">
          <video autoplay loop muted class="container__section_top__article_bottom__div__video">
            <source src="@/assets/videos/web.mp4" type="video/mp4"
              class="container__section_top__article_bottom__div__video__source" />
            <source />
          </video>
        </div>
      </article>
    </section>

    <!-- section middle -->

    <section class="container__section_middle">
      <article class="container__section_middle__article_top">
        <aside class="container__section_middle__article_top__aside_top">
          <div class="container__section_middle__article_top__aside_top__div">
            <h1 class="container__section_middle__article_top__aside_top__div__h1">
              Compétences
            </h1>
          </div>
        </aside>
        <!-- left side-->
        <aside class="container__section_middle__article_top__aside_left">
          <!-- icons -->
          <div class="container__section_middle__article_top__aside_left__div_card">
            <!--  -->
            <div class="container__section_middle__article_top__aside_left__div_card__div_solidworks">
              <div class="container__section_middle__article_top__aside_left__div_card__div_solidworks__div_icon">
                <a href="https://fr.wikipedia.org/wiki/SolidWorks">
                  <img src="@/assets/solidworks_icon-icons.com.png" alt="solidworks_icon"
                    class="container__section_middle__article_top__aside_left__div_card__div_solidworks__div_icon__img" />
                </a>
              </div>
              <!--  -->
              <div class="container__section_middle__article_top__aside_left__div_card__div_solidworks__div_link">
                <p class="container__section_middle__article_top__aside_left__div_card__div_solidworks__div_link__a">
                  Solidworks</p>
              </div>
            </div>
            <!--  -->
            <div class="container__section_middle__article_top__aside_left__div_card__div_pencil">
              <div class="container__section_middle__article_top__aside_left__div_card__div_pencil__div_icon">
                <a href="https://www.formation-industries-paca.fr/formations/conception-de-produits-industriels-cpi/">
                  <img src="@/assets/pencil-write.png" alt="pencil"
                    class="container__section_middle__article_top__aside_left__div_card__div_pencil__div_icon__img" />
                </a>

              </div>
              <!--  -->
              <div class="container__section_middle__article_top__aside_left__div_card__div_pencil__div_link">
                <p class="container__section_middle__article_top__aside_left__div_card__div_pencil__div_link__a">
                  Conception
                  industriel</p>
              </div>
            </div>
            <!--  -->
            <div class="container__section_middle__article_top__aside_left__div_card__div_sheet">
              <div class="container__section_middle__article_top__aside_left__div_card__div_sheet__div_icon">
                <a href="https://remeca.fr/mise-en-plan/">
                  <img src="@/assets/real_estate.png" alt="real_estate"
                    class="container__section_middle__article_top__aside_left__div_card__div_sheet__div_icon__img" />
                </a>
              </div>
              <!--  -->
              <div class="container__section_middle__article_top__aside_left__div_card__div_sheet__div_link">
                <p class="container__section_middle__article_top__aside_left__div_card__div_sheet__div_link__a">Mise en
                  plan</p>
              </div>
            </div>
          </div>
        </aside>

        <!-- right aside -->

        <aside class="container__section_middle__article_top__aside_right">
          <!-- right side -->
          <div class="container__section_middle__article_top__aside_right__div_top">
            <div class="container__section_middle__article_top__aside_right__div_top__div_titre">
              <h1 class="container__section_middle__article_top__aside_right__div_top__div_titre__h1">
                Dessinateur industriel
              </h1>
            </div>
            <div class="container__section_middle__article_top__aside_right__div_top__div_text">
              <p class="container__section_middle__article_top__aside_right__div_top__div_text__p">
                Etude et
                <br />
                définition
              </p>
            </div>
          </div>
          <!-- flex direction column -->
          <div class="container__section_middle__article_top__aside_right__div_bottom">
            <button class="container__section_middle__article_top__aside_right__div_bottom__button">
              <router-link to="/services#industriel"
                class="container__section_middle__article_top__aside_right__div_bottom__button__router-link">
                Prestations
              </router-link>
            </button>
          </div>
        </aside>
      </article>
      <article class="container__section_middle__article_bottom">
        <div class="container__section_middle__article_bottom__div">
          <video src="@/assets/videos/edpi.mp4" autoplay loop muted
            class="container__section_middle__article_bottom__div__video"></video>
        </div>
      </article>
    </section>
    <!-- ******************************************** -->
    <!-- ************** Bottom Section *************-->
    <!-- ******************************************** -->
    <section class="container__section_bottom">
      <article class="container__section_bottom__article_top">
        <aside class="container__section_bottom__article_top__aside_top">
          <div class="container__section_bottom__article_top__aside_top__div">
            <h1 class="container__section_bottom__article_top__aside_top__div__h1">
              Compétences
            </h1>
          </div>
        </aside>
        <!-- left side-->
        <aside class="container__section_bottom__article_top__aside_left">
          <!-- icons -->
          <div class="container__section_bottom__article_top__aside_left__div_card">
            <!--  -->
            <div class="container__section_bottom__article_top__aside_left__div_card__div_soldier">
              <div class="container__section_bottom__article_top__aside_left__div_card__div_soldier__div_icon">
                <a href="https://fr.wikipedia.org/wiki/Instruction_sur_le_tir_de_combat">
                  <img src="@/assets/soldier.png" alt="soldier"
                    class="container__section_bottom__article_top__aside_left__div_card__div_soldier__div_icon__img" />
                </a>
              </div>
              <!--  -->
              <div class="container__section_bottom__article_top__aside_left__div_card__div_soldier__div_link">
                <p class="container__section_bottom__article_top__aside_left__div_card__div_soldier__div_link__a">Tir de
                  combat</p>
              </div>
            </div>
            <!--  -->
            <div class="container__section_bottom__article_top__aside_left__div_card__div_gun">
              <div class="container__section_bottom__article_top__aside_left__div_card__div_gun__div_icon">
                <a href="https://www.orientation.com/metiers/moniteur-de-tir">
                  <img src="@/assets/gun-pistol.png" alt="pistol"
                    class="container__section_bottom__article_top__aside_left__div_card__div_gun__div_icon__img" />
                </a>
              </div>
              <!--  -->
              <div class="container__section_bottom__article_top__aside_left__div_card__div_gun__div_link">
                <p class="container__section_bottom__article_top__aside_left__div_card__div_gun__div_link__a">
                  Instructeur
                  de tir</p>
              </div>
            </div>
            <!--  -->
            <div class="container__section_bottom__article_top__aside_left__div_card__div_defense">
              <div class="container__section_bottom__article_top__aside_left__div_card__div_defense__div_icon">
                <a href="https://fr.wikipedia.org/wiki/L%C3%A9gitime_d%C3%A9fense_en_droit_fran%C3%A7ais">
                  <img src="@/assets/defense.png" alt="defense"
                    class="container__section_bottom__article_top__aside_left__div_card__div_defense__div_icon__img" />
                </a>
              </div>
              <!--  -->
              <div class="container__section_bottom__article_top__aside_left__div_card__div_defense__div_link">
                <p class="container__section_bottom__article_top__aside_left__div_card__div_defense__div_link__a">
                  Défense</p>
              </div>
            </div>
          </div>
        </aside>

        <!-- right aside -->

        <aside class="container__section_bottom__article_top__aside_right">
          <!-- right side -->
          <div class="container__section_bottom__article_top__aside_right__div_top">
            <div class="container__section_bottom__article_top__aside_right__div_top__div_titre">
              <h1 class="container__section_bottom__article_top__aside_right__div_top__div_titre__h1">
                Instructeur de tir
              </h1>
            </div>
            <div class="container__section_bottom__article_top__aside_right__div_top__div_text">
              <p class="container__section_bottom__article_top__aside_right__div_top__div_text__p">
                Combat et
                <br />
                Tactique
              </p>
            </div>
          </div>
          <!-- flex direction column -->
          <div class="container__section_bottom__article_top__aside_right__div_bottom">
            <button class="container__section_bottom__article_top__aside_right__div_bottom__button">
              <router-link to="/services#tir"
                class="container__section_bottom__article_top__aside_right__div_bottom__button__router-link">
                Prestations
              </router-link>
            </button>
          </div>
        </aside>
      </article>
      <article class="container__section_bottom__article_bottom">
        <div class="container__section_bottom__article_bottom__div">
          <video src="@/assets/videos/glock.mp4" autoplay loop muted
            class="container__section_bottom__article_bottom__div__video"></video>
        </div>
      </article>
    </section>
  </main>
  <!--  section expériences -->
  <section class="section_xp">
    <div class="section_xp__div">Expérience</div>
  </section>
</template>

<script>
export default {
  name: "AccueilDesktop",
};

</script>

<style lang="scss" scoped>

//@import "@/style/components/accueil/AccueilDesktop.scss";

@import "@/style/color.scss";
@import "@/style/effets.scss";

.container {
  margin: auto;
  overflow: hidden;
  //background-color: $BG;

  &__section_top {
    display: flex;
    overflow: hidden;
    flex-direction: column;
    //background-color: $BG;

    &__article_top {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      grid-template-rows: repeat(2, 1fr);
      grid-column-gap: 0px;
      grid-row-gap: 0px;
      height: 35rem;
      padding-bottom: 2rem;
      background-color: $BG;
      overflow: hidden;


      &__aside_top {
        grid-row-start: 1;
        grid-row-end: 2;
        grid-column-start: 1;
        grid-column-end: 3;
        margin-right: auto;
        margin-left: auto;
        height: 4rem;

        &__div {
          text-align: center;
          margin-right: 20vw;

          &__h1 {
            font-size: $competences;
            font-weight: normal;
          }
        }
      }

      // aside bottom left

      &__aside_left {
        grid-row-start: 2;
        grid-row-end: 3;
        grid-column-start: 1;
        grid-column-end: 2;

        &__div_card {
          display: grid;
          grid-template-columns: repeat(5, 1fr);
          grid-template-rows: repeat(2, 1fr);
          grid-column-gap: $card-gap;
          grid-row-gap: $card-gap;
          margin-left: 1vw;
          width: 54vw;

          // ####################

          // card angular

          &__div_angular {
            grid-row-start: 1;
            grid-row-end: 2;
            grid-column-start: 1;
            grid-column-end: 2;

            max-width: $card-width;
            max-height: $card-height;
            min-width: $min-size;
            min-height: $min-size;

            box-shadow: $ombres;
            border-radius: $radius-card;
            background-color: white;
            margin: auto;

            &__div_icon {
              width: $icon-width;
              height: $icon-height;
              min-width: $min-icon;
              min-height: $min-icon;
              overflow: hidden;
              margin: 1vw;
              display: flex;
              align-self: center;

              position: relative;
              z-index: 2;
              background-color: white;

              &__img {
                max-width: $icon-width;
                max-height: $icon-height;
                min-width: $min-icon;
                min-height: $min-icon;
                margin: auto;
              }
            }

            // link

            &__div_link {
              margin: auto;
              position: relative;
              z-index: 1;
              text-align: center;
              bottom: 6vw;

              &__a {
                font-size: $text;
              }
            }

            // hover

            &__div_icon:hover {
              opacity: 0%;
              transition-duration: 1s;
            }
          }

          // card vue

          &__div_vue {
            grid-row-start: 1;
            grid-row-end: 2;
            grid-column-start: 2;
            grid-column-end: 3;

            max-width: $card-width;
            max-height: $card-height;
            min-width: $min-size;
            min-height: $min-size;

            box-shadow: $ombres;
            border-radius: $radius-card;
            background-color: white;
            margin: auto;

            &__div_icon {
              width: $icon-width;
              height: $icon-height;
              overflow: hidden;
              margin: 1vw;
              display: flex;
              position: relative;
              z-index: 2;
              background-color: white;

              &__img {
                width: $icon-width;
                height: $icon-height;
                margin: auto;
              }
            }

            // link

            &__div_link {
              margin: auto;
              position: relative;
              z-index: 1;
              text-align: center;
              bottom: 6vw;

              &__a {
                font-size: $text;
              }
            }

            // hover

            &__div_icon:hover {
              opacity: 0%;
              transition-duration: 1s;
            }
          }

          // card react

          &__div_react {
            grid-row-start: 1;
            grid-row-end: 2;
            grid-column-start: 3;
            grid-column-end: 4;

            max-width: $card-width;
            max-height: $card-height;
            min-width: $min-size;
            min-height: $min-size;

            box-shadow: $ombres;
            border-radius: $radius-card;
            background-color: white;
            margin: auto;

            &__div_icon {
              width: $icon-width;
              height: $icon-height;
              overflow: hidden;
              margin: 1vw;
              display: flex;
              position: relative;
              z-index: 2;
              background-color: white;

              &__img {
                width: $icon-width;
                height: $icon-height;
                margin: auto;
              }
            }

            // link

            &__div_link {
              margin: auto;
              position: relative;
              z-index: 1;
              text-align: center;
              bottom: 6vw;

              &__a {
                font-size: $text;
              }
            }

            // hover

            &__div_icon:hover {
              opacity: 0%;
              transition-duration: 1s;
            }
          }

          // card symfony

          &__div_symfony {
            grid-row-start: 1;
            grid-row-end: 2;
            grid-column-start: 4;
            grid-column-end: 5;

            max-width: $card-width;
            max-height: $card-height;
            min-width: $min-size;
            min-height: $min-size;

            box-shadow: $ombres;
            border-radius: $radius-card;
            background-color: white;
            margin: auto;

            &__div_icon {
              width: $icon-width;
              height: $icon-height;
              overflow: hidden;
              margin: 1vw;
              display: flex;
              position: relative;
              z-index: 2;
              background-color: white;

              &__img {
                width: $icon-width;
                height: $icon-height;
                margin: auto;
              }
            }

            // link

            &__div_link {
              margin: auto;
              position: relative;
              z-index: 1;
              text-align: center;
              bottom: 6vw;

              &__a {
                font-size: $text;
              }
            }

            // hover

            &__div_icon:hover {
              opacity: 0%;
              transition-duration: 1s;
            }
          }

          // card sql

          &__div_sql {
            grid-row-start: 1;
            grid-row-end: 2;
            grid-column-start: 5;
            grid-column-end: 6;

            max-width: $card-width;
            max-height: $card-height;
            min-width: $min-size;
            min-height: $min-size;

            box-shadow: $ombres;
            border-radius: $radius-card;
            background-color: white;
            margin: auto;

            &__div_icon {
              width: $icon-width;
              height: $icon-height;
              overflow: hidden;
              margin: 1vw;
              display: flex;
              position: relative;
              z-index: 2;
              background-color: white;

              &__img {
                width: $icon-width;
                height: $icon-height;
                margin: auto;
              }
            }

            // link

            &__div_link {
              margin: auto;
              position: relative;
              z-index: 1;
              text-align: center;
              bottom: 6vw;

              &__a {
                font-size: $text;
              }
            }

            // hover

            &__div_icon:hover {
              opacity: 0%;
              transition-duration: 1s;
            }
          }

          // card html

          &__div_html5 {
            grid-row-start: 2;
            grid-row-end: 3;
            grid-column-start: 1;
            grid-column-end: 2;

            max-width: $card-width;
            max-height: $card-height;
            min-width: $min-size;
            min-height: $min-size;

            box-shadow: $ombres;
            border-radius: $radius-card;
            background-color: white;
            margin: auto;

            &__div_icon {
              width: $icon-width;
              height: $icon-height;
              overflow: hidden;
              margin: 1vw;
              display: flex;
              position: relative;
              z-index: 2;
              background-color: white;

              &__img {
                width: $icon-width;
                height: $icon-height;
                margin: auto;
              }
            }

            // link

            &__div_link {
              margin: auto;
              position: relative;
              z-index: 1;
              text-align: center;
              bottom: 6vw;

              &__a {
                font-size: $text;
              }
            }

            // hover

            &__div_icon:hover {
              opacity: 0%;
              transition-duration: 1s;
            }
          }

          // card css

          &__div_css3 {
            grid-row-start: 2;
            grid-row-end: 3;
            grid-column-start: 2;
            grid-column-end: 3;

            max-width: $card-width;
            max-height: $card-height;
            min-width: $min-size;
            min-height: $min-size;

            box-shadow: $ombres;
            border-radius: $radius-card;
            background-color: white;

            &__div_icon {
              width: $icon-width;
              height: $icon-height;
              overflow: hidden;
              margin: 1vw;
              display: flex;
              position: relative;
              z-index: 2;
              background-color: white;

              &__img {
                width: $icon-width;
                height: $icon-height;
                margin: auto;
              }
            }

            // link

            &__div_link {
              margin: auto;
              position: relative;
              z-index: 1;
              text-align: center;
              bottom: 6vw;

              &__a {
                font-size: $text;
              }
            }

            // hover

            &__div_icon:hover {
              opacity: 0%;
              transition-duration: 1s;
            }
          }

          // card js

          &__div_js {
            grid-row-start: 2;
            grid-row-end: 3;
            grid-column-start: 3;
            grid-column-end: 4;

            max-width: $card-width;
            max-height: $card-height;
            min-width: $min-size;
            min-height: $min-size;

            box-shadow: $ombres;
            border-radius: $radius-card;
            background-color: white;

            &__div_icon {
              width: $icon-width;
              height: $icon-height;
              overflow: hidden;
              margin: 1vw;
              display: flex;
              position: relative;
              z-index: 2;
              background-color: white;

              &__img {
                width: $icon-width;
                height: $icon-height;
                margin: auto;
              }
            }

            // link

            &__div_link {
              margin: auto;
              position: relative;
              z-index: 1;
              text-align: center;
              bottom: 6vw;

              &__a {
                font-size: $text;
              }
            }

            // hover

            &__div_icon:hover {
              opacity: 0%;
              transition-duration: 1s;
            }
          }

          // card php

          &__div_php {
            grid-row-start: 2;
            grid-row-end: 3;
            grid-column-start: 4;
            grid-column-end: 5;

            max-width: $card-width;
            max-height: $card-height;
            min-width: $min-size;
            min-height: $min-size;

            box-shadow: $ombres;
            border-radius: $radius-card;
            background-color: white;

            &__div_icon {
              width: $icon-width;
              height: $icon-height;
              overflow: hidden;
              margin: 1vw;
              display: flex;
              position: relative;
              z-index: 2;
              background-color: white;

              &__img {
                width: $icon-width;
                height: $icon-height;
                margin: auto;
              }
            }

            // link

            &__div_link {
              margin: auto;
              position: relative;
              z-index: 1;
              text-align: center;
              bottom: 6vw;

              &__a {
                font-size: $text;
              }
            }

            // hover

            &__div_icon:hover {
              opacity: 0%;
              transition-duration: 1s;
            }
          }

          // card python

          &__div_python {
            grid-row-start: 2;
            grid-row-end: 3;
            grid-column-start: 5;
            grid-column-end: 6;

            max-width: $card-width;
            max-height: $card-height;
            min-width: $min-size;
            min-height: $min-size;

            box-shadow: $ombres;
            border-radius: $radius-card;
            background-color: white;

            &__div_icon {
              width: $icon-width;
              height: $icon-height;
              overflow: hidden;
              margin: 1vw;
              display: flex;
              position: relative;
              z-index: 2;
              background-color: white;

              &__img {
                width: $icon-width;
                height: $icon-height;
                margin: auto;
              }
            }

            // link

            &__div_link {
              margin: auto;
              position: relative;
              z-index: 1;
              text-align: center;
              bottom: 6vw;

              &__a {
                font-size: $text;
              }
            }

            // hover

            &__div_icon:hover {
              opacity: 0%;
              transition-duration: 1s;
            }
          }
        }
      }

      // aside bottom right

      &__aside_right {
        grid-row-start: 2;
        grid-row-end: 3;
        grid-column-start: 2;
        grid-column-end: 3;

        display: flex;
        flex-direction: column;
        position: relative;
        left: 12vw;
        width: 24vw;

        &__div_top {
          position: relative;
          bottom: 4rem;
          box-shadow: $ombres;
          max-width: 24vw;
          min-width: 24rem;
          border-radius: $radius-card;
          height: 10rem;


          &__div_titre {
            text-align: start;
            margin-left: 0.5vw;

            &__h1 {
              font-size: $h1;
            }
          }

          // texte

          &__div_text {
            text-align: end;
            margin-right: 0.5vw;

            &__p {
              font-size: $text;
            }
          }
        }

        // ##################

        &__div_bottom {
          text-align: center;
          align-self: center;
          margin-top: 10vw;

          &__button {
            border: none;
            height: 4rem;
            width: 14rem;
            background-color: $RV;
            border-radius: 2rem;

            &__router-link {
              text-align: center;
              color: white;
              font-size: $competences;
            }

            // hover router link

            &__router-link:hover {
              color: $GX;
            }
          }

          // hover button

          &__button:hover {
            border: solid 0.25rem white;
            background-color: $BG;
            transition-duration: 0.25s;
          }
        }
      }
    }

    // article bottom video 

    &__article_bottom {
      overflow: hidden;
      height: 24rem;
      //z-index: -3;

      &__div {
        height: 24rem;
        //border: solid 1rem red;
        overflow: hidden;
        margin: auto;
        z-index: -3;
        //opacity: 0%;
        //inset: 0px 0px 0px 0px;

        &__video {
          width: 100%;
          object-fit: cover;
          position: fixed;
          //margin-top:30rem;
          z-index: -3;
          inset: 0px 0px 5000px 0px;
        }
      }
    }
  }

  // ###################

  // Section middle

  //#####################

  &__section_middle {
    display: flex;
    overflow: hidden;
    flex-direction: column;
    //background-color: $BG;

    &__article_top {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      grid-template-rows: repeat(2, 1fr);
      grid-column-gap: 0px;
      grid-row-gap: 0px;
      height: 35rem;
      padding-bottom: 2rem;
      background-color: $BG;


      &__aside_top {
        grid-row-start: 1;
        grid-row-end: 2;
        grid-column-start: 1;
        grid-column-end: 3;
        margin-right: auto;
        margin-left: auto;
        height: 4rem;

        &__div {
          text-align: center;
          margin-right: 20vw;

          &__h1 {
            font-size: $competences;
            font-weight: normal;
          }
        }
      }

      // aside bottom left

      &__aside_left {
        grid-row-start: 2;
        grid-row-end: 3;
        grid-column-start: 1;
        grid-column-end: 2;

        &__div_card {
          display: grid;
          grid-template-columns: repeat(5, 1fr);
          grid-template-rows: repeat(2, 1fr);
          grid-column-gap: $card-gap;
          grid-row-gap: $card-gap;
          margin-left: 1vw;
          width: 54vw;

          // ####################

          // card solidworks

          &__div_solidworks {
            grid-row-start: 1;
            grid-row-end: 2;
            grid-column-start: 1;
            grid-column-end: 2;

            max-width: $card-width;
            max-height: $card-height;
            min-width: $min-size;
            min-height: $min-size;

            box-shadow: $ombres;
            border-radius: $radius-card;
            background-color: white;
            margin: auto;

            &__div_icon {
              width: $icon-width;
              height: $icon-height;
              min-width: $min-icon;
              min-height: $min-icon;
              overflow: hidden;
              margin: 1vw;
              display: flex;
              align-self: center;

              position: relative;
              z-index: 2;
              background-color: white;

              &__img {
                max-width: $icon-width;
                max-height: $icon-height;
                min-width: $min-icon;
                min-height: $min-icon;
                margin: auto;
              }
            }

            // link

            &__div_link {
              margin: auto;
              position: relative;
              z-index: 1;
              text-align: center;
              bottom: 6vw;

              &__a {
                font-size: $text;
              }
            }

            // hover

            &__div_icon:hover {
              opacity: 0%;
              transition-duration: 1s;
            }
          }

          // card conception industriel

          &__div_pencil {
            grid-row-start: 1;
            grid-row-end: 2;
            grid-column-start: 2;
            grid-column-end: 3;

            max-width: $card-width;
            max-height: $card-height;
            min-width: $min-size;
            min-height: $min-size;

            box-shadow: $ombres;
            border-radius: $radius-card;
            background-color: white;
            margin: auto;

            &__div_icon {
              width: $icon-width;
              height: $icon-height;
              overflow: hidden;
              margin: 1vw;
              display: flex;
              position: relative;
              z-index: 2;
              background-color: white;

              &__img {
                width: $icon-width;
                height: $icon-height;
                margin: auto;
              }
            }

            // link

            &__div_link {
              margin: auto;
              position: relative;
              z-index: 1;
              text-align: center;
              bottom: 6vw;

              &__a {
                font-size: $text;
              }
            }

            // hover

            &__div_icon:hover {
              opacity: 0%;
              transition-duration: 1s;
            }
          }

          // card sheet

          &__div_sheet {
            grid-row-start: 1;
            grid-row-end: 2;
            grid-column-start: 3;
            grid-column-end: 4;

            max-width: $card-width;
            max-height: $card-height;
            min-width: $min-size;
            min-height: $min-size;

            box-shadow: $ombres;
            border-radius: $radius-card;
            background-color: white;
            margin: auto;

            &__div_icon {
              width: $icon-width;
              height: $icon-height;
              overflow: hidden;
              margin: 1vw;
              display: flex;
              position: relative;
              z-index: 2;
              background-color: white;

              &__img {
                width: $icon-width;
                height: $icon-height;
                margin: auto;
              }
            }

            // link

            &__div_link {
              margin: auto;
              position: relative;
              z-index: 1;
              text-align: center;
              bottom: 6vw;

              &__a {
                font-size: $text;
              }
            }

            // hover

            &__div_icon:hover {
              opacity: 0%;
              transition-duration: 1s;
            }
          }
        }
      }

      // aside bottom right

      &__aside_right {
        grid-row-start: 2;
        grid-row-end: 3;
        grid-column-start: 2;
        grid-column-end: 3;

        display: flex;
        flex-direction: column;
        position: relative;
        left: 12vw;
        width: 24vw;

        &__div_top {
          position: relative;
          bottom: 4rem;
          box-shadow: $ombres;
          max-width: 24vw;
          min-width: 24rem;
          border-radius: $radius-card;
          height: 10rem;


          &__div_titre {
            text-align: start;
            margin-left: 0.5vw;

            &__h1 {
              font-size: $h1;
            }
          }

          // texte

          &__div_text {
            text-align: end;
            margin-right: 0.5vw;

            &__p {
              font-size: $text;
            }
          }
        }

        // ##################

        &__div_bottom {
          text-align: center;
          align-self: center;
          margin-top: 10vw;

          &__button {
            border: none;
            height: 4rem;
            width: 14rem;
            background-color: $RV;
            border-radius: 2rem;

            &__router-link {
              text-align: center;
              color: white;
              font-size: $competences;
            }

            // hover router link

            &__router-link:hover {
              color: $GX;
            }
          }

          // hover button

          &__button:hover {
            border: solid 0.25rem white;
            background-color: $BG;
            transition-duration: 0.25s;
          }
        }
      }
    }

    // article bottom video 

    &__article_bottom {
      overflow: hidden;
      height: 24rem;
      margin-top: 0rem;
      width: 100vw;

      &__div {
        height: 24rem;
        width: inherit;
        overflow: hidden;
        margin: auto;
        z-index: -2;


        &__video {
          width: 100%;
          object-fit: cover;
        }
      }
    }
  }

  // ###################

  // Section bottom

  //#####################

  &__section_bottom {
    display: flex;
    overflow: hidden;
    flex-direction: column;

    &__article_top {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      grid-template-rows: repeat(2, 1fr);
      grid-column-gap: 0px;
      grid-row-gap: 0px;
      height: 35rem;
      padding-bottom: 2rem;
      background-color: $BG;


      &__aside_top {
        grid-row-start: 1;
        grid-row-end: 2;
        grid-column-start: 1;
        grid-column-end: 3;
        margin-right: auto;
        margin-left: auto;
        height: 4rem;

        &__div {
          text-align: center;
          margin-right: 20vw;

          &__h1 {
            font-size: $competences;
            font-weight: normal;
          }
        }
      }

      // aside bottom left

      &__aside_left {
        grid-row-start: 2;
        grid-row-end: 3;
        grid-column-start: 1;
        grid-column-end: 2;

        &__div_card {
          display: grid;
          grid-template-columns: repeat(5, 1fr);
          grid-template-rows: repeat(2, 1fr);
          grid-column-gap: $card-gap;
          grid-row-gap: $card-gap;
          margin-left: 1vw;
          width: 54vw;

          // ####################

          // card soldier

          &__div_soldier {
            grid-row-start: 1;
            grid-row-end: 2;
            grid-column-start: 1;
            grid-column-end: 2;

            max-width: $card-width;
            max-height: $card-height;
            min-width: $min-size;
            min-height: $min-size;

            box-shadow: $ombres;
            border-radius: $radius-card;
            background-color: white;
            margin: auto;

            &__div_icon {
              width: $icon-width;
              height: $icon-height;
              min-width: $min-icon;
              min-height: $min-icon;
              overflow: hidden;
              margin: 1vw;
              display: flex;
              align-self: center;

              position: relative;
              z-index: 2;
              background-color: white;

              &__img {
                max-width: $icon-width;
                max-height: $icon-height;
                min-width: $min-icon;
                min-height: $min-icon;
                margin: auto;
              }
            }

            // link

            &__div_link {
              margin: auto;
              position: relative;
              z-index: 1;
              text-align: center;
              bottom: 6vw;

              &__a {
                font-size: $text;
              }
            }

            // hover

            &__div_icon:hover {
              opacity: 0%;
              transition-duration: 1s;
            }
          }

          // card gun

          &__div_gun {
            grid-row-start: 1;
            grid-row-end: 2;
            grid-column-start: 2;
            grid-column-end: 3;

            max-width: $card-width;
            max-height: $card-height;
            min-width: $min-size;
            min-height: $min-size;

            box-shadow: $ombres;
            border-radius: $radius-card;
            background-color: white;
            margin: auto;

            &__div_icon {
              width: $icon-width;
              height: $icon-height;
              overflow: hidden;
              margin: 1vw;
              display: flex;
              position: relative;
              z-index: 2;
              background-color: white;

              &__img {
                width: $icon-width;
                height: $icon-height;
                margin: auto;
              }
            }

            // link

            &__div_link {
              margin: auto;
              position: relative;
              z-index: 1;
              text-align: center;
              bottom: 6vw;
              width: 5vw;

              &__a {
                font-size: $text;
              }
            }

            // hover

            &__div_icon:hover {
              opacity: 0%;
              transition-duration: 1s;
            }
          }

          // card defense

          &__div_defense {
            grid-row-start: 1;
            grid-row-end: 2;
            grid-column-start: 3;
            grid-column-end: 4;

            max-width: $card-width;
            max-height: $card-height;
            min-width: $min-size;
            min-height: $min-size;

            box-shadow: $ombres;
            border-radius: $radius-card;
            background-color: white;
            margin: auto;

            &__div_icon {
              width: $icon-width;
              height: $icon-height;
              overflow: hidden;
              margin: 1vw;
              display: flex;
              position: relative;
              z-index: 2;
              background-color: white;

              &__img {
                width: $icon-width;
                height: $icon-height;
                margin: auto;
              }
            }

            // link

            &__div_link {
              margin: auto;
              position: relative;
              z-index: 1;
              text-align: center;
              bottom: 6vw;

              &__a {
                font-size: $text;
              }
            }

            // hover

            &__div_icon:hover {
              opacity: 0%;
              transition-duration: 1s;
            }
          }
        }
      }

      // aside bottom right

      &__aside_right {
        grid-row-start: 2;
        grid-row-end: 3;
        grid-column-start: 2;
        grid-column-end: 3;

        display: flex;
        flex-direction: column;
        position: relative;
        left: 12vw;
        width: 24vw;

        &__div_top {
          position: relative;
          bottom: 4rem;
          box-shadow: $ombres;
          max-width: 24vw;
          min-width: 24rem;
          border-radius: $radius-card;
          height: 10rem;


          &__div_titre {
            text-align: start;
            margin-left: 0.5vw;

            &__h1 {
              font-size: $h1;
            }
          }

          // texte

          &__div_text {
            text-align: end;
            margin-right: 0.5vw;

            &__p {
              font-size: $text;
            }
          }
        }

        // ##################

        &__div_bottom {
          text-align: center;
          align-self: center;
          margin-top: 10vw;

          &__button {
            border: none;
            height: 4rem;
            width: 14rem;
            background-color: $RV;
            border-radius: 2rem;

            &__router-link {
              text-align: center;
              color: white;
              font-size: $competences;
            }

            // hover router link

            &__router-link:hover {
              color: $GX;
            }
          }

          // hover button

          &__button:hover {
            border: solid 0.25rem white;
            background-color: $BG;
            transition-duration: 0.25s;
          }
        }
      }
    }

    // article bottom video 

    &__article_bottom {
      overflow: hidden;
      height: 24rem;
      margin-top: 0rem;
      width: 100vw;

      &__div {
        height: 24rem;
        width: inherit;
        overflow: hidden;
        margin: auto;
        z-index: -2;


        &__video {
          width: 100%;
          object-fit: cover;
          position: relative;
          bottom: 15rem;
        }
      }
    }
  }
}

.section_xp {
  display: none;
}

@media screen and(max-width: 926px){
  .container{
    display: none;
  }
}
</style>
